



























import { Component, Vue, Watch, Ref } from 'vue-property-decorator';
import DisplayItemPartition from '@/components/display-items/DisplayItemPartition.vue';
import DisplayItemChunk from '@/components/display-items/DisplayItemChunk.vue';
import {DisplayItem} from '@/types/DisplayItem';


/**
 * Component for showing all previous partitions and nested chunks
 * contains:
 * DisplayItemPartition
 * DisplayItemChunk
 */
@Component({
    props: {
        /**
         * Should the newest items be shown at the top
         */
        topFirst: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        DisplayItemPartition,
        DisplayItemChunk
    }
})
export default class PreviousDisplayItemsList extends Vue {

    private partitionExpanded: boolean[] = [];

    private created() {
        this.onPartitionsChanged(this.partitions);
    }

    // Keep the partitionsExpanded array in line with the actual number of partitions
    @Watch('partitions')
    private onPartitionsChanged(newPartitions: Array<[DisplayItem, number]>) {
        const oldlen = this.partitionExpanded.length;
        const newlen = newPartitions.length;

        if (oldlen > newlen) {
            // Cut off unneeded items
            this.partitionExpanded.length = newlen;
        } else if (newlen > oldlen) {
            this.partitionExpanded.length = newlen;
            for (let i = oldlen; i < newlen; i++) {
                this.partitionExpanded[i] = false;
            }
        }
    }

    get partitions() {
        return this.$store.getters['performance/getPartitions'];
    }

    private getPartitionChunks(index: number) {
        if (this.$props.topFirst) {
            return this.$store.getters['performance/getPartitionChunks'](index).slice().reverse();
        } else {

            // Reverse a copy
            return this.$store.getters['performance/getPartitionChunks'](index);
        }
    }

    private togglePartitionExpanded(index: number) {

        if (!this.$props.topFirst) {
            this.$emit('scrollresetrequired');
        }

        Vue.set(this.partitionExpanded, index, !this.partitionExpanded[index]);
    }

}
